import axionIns from "../axios";

const getPayoutList = (page, limit, search, status, companyId = '') => {
    return axionIns.get(`admin/advisorpayout?page=${page}&perPage=${limit}&search=${search}&status=${status}&company=${companyId}`).then((response) => {
        return response.data;
    });
};

const paytoAdvisor = (payload) => {
    return axionIns.post(`admin/advisorpayout`, JSON.stringify(payload)).then((response) => {
        return response.data;
    });
};




const exportObject = { getPayoutList, paytoAdvisor };
export default exportObject;
